import { Route } from "react-router-dom";
import Login from "../external/ensolvers-core-frontend-mui/components/Main/Login";
import UsersList from "../routes/UsersList";
import TimeoffList from "../routes/TimeoffList";
import ProjectList from "../routes/ProjectList";
import WorkLogList from "../routes/WorkLogList";
import WorkLogReportList from "../routes/WorklogReportList";
import PositionList from "../routes/PositionList";
import environment from "../environment.json";
import HolidayList from "../routes/HolidayList";
import AssignationList from "../routes/AssignationList";
import WorklogSummaryList from "../routes/WorklogSummaryList";
import PersonalInfo from "../routes/PersonalInfo";
import AssignationProjectionList from "../routes/AssignationProjectionList";
import { Routes } from "../types/Routes";
import CertificationList from "../routes/CertificationList";
import AuthService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/AuthService";
import RoleUtils from "../utils/RoleUtils";
import { Redirect } from "react-router-dom";
import OverStaffReportList from "../routes/OverStaffReportList";
import KnowledgeBaseList from "../routes/KnowledgeBaseList";
import Dashboard from "../routes/Dashboard";
import TimeOffReportList from "../routes/TimeOffReportList";
import VacationReportList from "../routes/VacationReportList";
import FAQSection from "../routes/FAQSection";
import SiteList from "../routes/SiteList";
import MissingHoursReport from "./WorklogReport/MissingHoursReport";
import TimeOffExternalSummary from "./TimeOffReport/TimeOffExternalSummary";
import PropertiesList from "../routes/PropertiesList";
import AccomplishmentSection from "../routes/AccomplishmentSection";
import AccomplishmentApproval from "../routes/AccomplishmentApproval";
import { MonthlyRanking } from "../routes/MonthlyRanking";
import BadgeList from "../routes/BadgeList";
import { ValidatorSwitchWrapper } from "./ValidatorSwitchWrapper";
import ImageTemplateBuilder from "../routes/ImageTemplateBuilder";
import ProjectTimelineView from "../routes/ProjectTimeline";
import UnifiedReports from "../routes/UnifiedReports";
import InvoiceGenerator from "../routes/InvoiceGenerator";

/** Redirect the user to '/home' if they don't have the required roles for the route. */
function RouteAuthWrapper(props: { route: Routes; children: JSX.Element }) {
  return AuthService.hasAnyRole(RoleUtils.roleAccessDictionary[props.route]) ? props.children : <Redirect to="/home" />;
}

interface Props {
  isLogged: boolean;
  landingPage?: string;
}

export default function AppNavigation(props: Props) {
  return (
    <ValidatorSwitchWrapper>
      <Route exact path="/">
        {!props.isLogged && (
          <Login
            useSnackBar={true}
            register={false}
            useEmail={environment.allowEmailLogin}
            loginWithGoogle={true}
            allowToRegister={false}
            imageLogo={process.env.PUBLIC_URL + "/OPS_Logo.png"}
            topic="code"
            customStyle={{ height: "80vh" }}
          />
        )}
      </Route>
      <Route exact path={Routes.REGISTER}>
        {!props.isLogged && <Login register={true} />}
      </Route>

      <Route
        exact
        path={[`${Routes.WORKLOG}/:paramUserExternalId/:assignationExternalId`, `${Routes.WORKLOG}/:paramUserExternalId`, Routes.WORKLOG]}
      >
        <RouteAuthWrapper route={Routes.WORKLOG} children={<WorkLogList />} />
      </Route>
      <Route exact path={Routes.INVOICE_GENERATOR}>
        <RouteAuthWrapper route={Routes.INVOICE_GENERATOR} children={<InvoiceGenerator />} />
      </Route>
      <Route exact path={Routes.TIME_OFF}>
        <RouteAuthWrapper route={Routes.TIME_OFF} children={<TimeoffList />} />
      </Route>
      <Route exact path={Routes.PROJECTS}>
        <RouteAuthWrapper route={Routes.PROJECTS} children={<ProjectList />} />
      </Route>
      <Route exact path={Routes.PROJECTS_TIMELINE}>
        <RouteAuthWrapper route={Routes.PROJECTS_TIMELINE} children={<ProjectTimelineView />} />
      </Route>
      <Route exact path={Routes.FAQS}>
        <RouteAuthWrapper route={Routes.FAQS} children={<FAQSection />} />
      </Route>
      <Route exact path={Routes.WORKLOG_REPORT}>
        <RouteAuthWrapper route={Routes.WORKLOG_REPORT} children={<WorkLogReportList />} />
      </Route>
      <Route exact path={[`${Routes.ASSIGNATIONS}/:paramAssignationExternalId`, Routes.ASSIGNATIONS]}>
        <RouteAuthWrapper route={Routes.ASSIGNATIONS} children={<AssignationList />} />
      </Route>
      <Route exact path={[`${Routes.POSITIONS}/:paramPositionExternalId`, Routes.POSITIONS]}>
        <RouteAuthWrapper route={Routes.POSITIONS} children={<PositionList />} />
      </Route>
      <Route exact path={[`${Routes.ACCOMPLISHMENT_APPROVAL}`]}>
        <RouteAuthWrapper route={Routes.ACCOMPLISHMENT_APPROVAL} children={<AccomplishmentApproval />} />
      </Route>
      <Route exact path={Routes.ACCOMPLISHMENTS}>
        <RouteAuthWrapper route={Routes.ACCOMPLISHMENTS} children={<AccomplishmentSection />} />
      </Route>

      {/* ADMIN SECTION */}
      <Route exact path={Routes.USERS}>
        <RouteAuthWrapper route={Routes.USERS} children={<UsersList />} />
      </Route>
      <Route exact path={Routes.TIME_OFF_REPORT}>
        <RouteAuthWrapper route={Routes.TIME_OFF_REPORT} children={<TimeOffReportList />} />
      </Route>
      <Route exact path={Routes.VACATION_REPORT}>
        <RouteAuthWrapper route={Routes.VACATION_REPORT} children={<VacationReportList />} />
      </Route>
      <Route exact path={Routes.SITE}>
        <RouteAuthWrapper route={Routes.SITE} children={<SiteList />} />
      </Route>
      <Route exact path={Routes.HOLIDAYS}>
        <RouteAuthWrapper route={Routes.HOLIDAYS} children={<HolidayList />} />
      </Route>
      <Route exact path={Routes.BADGES}>
        <RouteAuthWrapper route={Routes.BADGES} children={<BadgeList />} />
      </Route>
      <Route exact path={Routes.WORKLOG_MISSING_HOURS}>
        <RouteAuthWrapper route={Routes.WORKLOG_MISSING_HOURS} children={<MissingHoursReport />} />
      </Route>
      <Route exact path={Routes.TIME_OFF_MISSING_HOURS}>
        <RouteAuthWrapper route={Routes.TIME_OFF_MISSING_HOURS} children={<TimeOffExternalSummary />} />
      </Route>
      <Route exact path={Routes.PROPERTIES}>
        <RouteAuthWrapper route={Routes.PROPERTIES} children={<PropertiesList />} />
      </Route>

      <Route exact path={[`${Routes.WORKLOGS_SUMMARY}/:paramProjectExternalId`, Routes.WORKLOGS_SUMMARY]}>
        <RouteAuthWrapper route={Routes.WORKLOGS_SUMMARY} children={<WorklogSummaryList />} />
      </Route>
      <Route exact path={[`${Routes.PROFILE}/:paramExternalId`, Routes.PROFILE]}>
        <RouteAuthWrapper route={Routes.PROFILE} children={<PersonalInfo />} />
      </Route>
      <Route exact path={Routes.CERTIFICATIONS}>
        <RouteAuthWrapper route={Routes.CERTIFICATIONS} children={<CertificationList />} />
      </Route>
      <Route exact path={Routes.ASSIGNATION_PROJECTION}>
        <RouteAuthWrapper route={Routes.ASSIGNATION_PROJECTION} children={<AssignationProjectionList />} />
      </Route>
      <Route exact path={Routes.OVER_STAFF_REPORT}>
        <RouteAuthWrapper route={Routes.OVER_STAFF_REPORT} children={<OverStaffReportList />} />
      </Route>
      <Route exact path={Routes.CERTIFICATIONS_LIST}>
        <RouteAuthWrapper route={Routes.CERTIFICATIONS_LIST} children={<CertificationList />} />
      </Route>
      <Route exact path={Routes.KNOWLEDGE_BASE_LIST}>
        <RouteAuthWrapper route={Routes.KNOWLEDGE_BASE_LIST} children={<KnowledgeBaseList />} />
      </Route>
      <Route exact path={Routes.IMAGE_TEMPLATE_BUILDER}>
        <RouteAuthWrapper route={Routes.IMAGE_TEMPLATE_BUILDER} children={<ImageTemplateBuilder />} />
      </Route>
      <Route exact path={Routes.DASHBOARD}>
        <RouteAuthWrapper route={Routes.DASHBOARD} children={<Dashboard />} />
      </Route>
      <Route exact path={[`${Routes.RANKING}?category=:category&month=:month`, Routes.RANKING]}>
        <RouteAuthWrapper route={Routes.RANKING} children={<MonthlyRanking />} />
      </Route>
      <Route exact path={Routes.UNIFIED_REPORTS}>
        <RouteAuthWrapper route={Routes.UNIFIED_REPORTS} children={<UnifiedReports />} />
      </Route>
      <Route path="*">{props.landingPage && <Redirect to={props.landingPage} />}</Route>
    </ValidatorSwitchWrapper>
  );
}
